import { toast } from "sonner";
import { formatUserError, shouldSkipErrorToast } from "@/lib/errors";

/** Toast an error unless session recovery / AuthGate owns the UX. */
export const toastUserError = (error: unknown, fallback: string): void => {
  if (shouldSkipErrorToast(error)) {
    return;
  }
  toast.error(formatUserError(error, fallback));
};
